import React from 'react';

import { useJobProspectsState, useJobProspectsActions } from './JobProspectsContext';
import JobProspectsLoader from './JobProspectsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import JobProspectsTable from './JobProspectsTable';
import JobProspectsEnrollment from './JobProspectsEnrollment';
import JobProspectsSettings from './JobProspectsSettings';
import PaymentMethodRequiredModal from './PaymentMethodRequiredModal';
import ClosedJobModal from './ClosedJobModal';
import GenerateResumeBetaModal from './GenerateResumeBetaModal';
import styles from './JobProspects.module.scss';

const JobProspects = ({ enrolled, tier, hasPaymentMethod, subscription }) => {
  const state = useJobProspectsState();
  const { setActiveTab } = useJobProspectsActions();

  const isEnrolled = state?.enrolled;
  const activeTab = state?.activeTab || 'prospects';

  return (
    <>
      <JobProspectsLoader
        enrolled={enrolled}
        tier={tier}
        hasPaymentMethod={hasPaymentMethod}
        subscription={subscription}
      />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'Job Prospects For You'} />

          {isEnrolled === false && (
            <JobProspectsEnrollment />
          )}

          {isEnrolled && (
            <>
              <div className={styles.tabBar}>
                <button
                  className={`${styles.tab} ${activeTab === 'prospects' ? styles.tabActive : ''}`}
                  onClick={() => setActiveTab('prospects')}
                >
                  Job Prospects
                </button>
                <button
                  className={`${styles.tab} ${activeTab === 'settings' ? styles.tabActive : ''}`}
                  onClick={() => setActiveTab('settings')}
                >
                  Settings
                </button>
              </div>

              {activeTab === 'prospects' && <JobProspectsTable />}
              {activeTab === 'settings' && <JobProspectsSettings />}
            </>
          )}
        </Stack>
      </div>
      <PaymentMethodRequiredModal />
      <ClosedJobModal />
      <GenerateResumeBetaModal />
    </>
  );
};

export default JobProspects;
